import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"width":"100%"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_BusinessOffer = _resolveComponent("BusinessOffer")!
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_row, { dense: "" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { cols: "1" }),
        _createVNode(_component_v_col, { cols: "10" }, {
          default: _withCtx(() => _cache[5] || (_cache[5] = [
            _createElementVNode("div", { class: "header" }, " Choix de l'offre ", -1)
          ])),
          _: 1
        }),
        _createVNode(_component_v_col, { cols: "1" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_btn_icon, {
              icon: "$oss-zoom-in",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isDialogOpen = true))
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_BusinessOffer, {
      isWithoutLogingView: true,
      isDisplayPrice: true,
      offer: _ctx._offer,
      "onUpdate:offer": _cache[1] || (_cache[1] = ($event: any) => ((_ctx._offer) = $event))
    }, null, 8, ["offer"]),
    _createVNode(_component_v_form, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_radio_group, {
          modelValue: _ctx._offer,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx._offer) = $event)),
          required: "",
          color: "primary"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "4" }),
                _createVNode(_component_v_col, { cols: "2" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_radio, {
                      class: "d-flex justify-center align-center",
                      value: 4
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, { cols: "2" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_radio, {
                      class: "d-flex justify-center align-center",
                      value: 8
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, { cols: "2" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_radio, {
                      class: "d-flex justify-center align-center",
                      value: 5
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, { cols: "2" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_radio, {
                      class: "d-flex justify-center align-center",
                      value: 6
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }),
    _createVNode(_component_oss_dialog, {
      "hide-valid": true,
      "hide-next": true,
      title: "offre",
      height: "100vh",
      width: "70vw",
      modelValue: _ctx.isDialogOpen,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.isDialogOpen) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_BusinessOffer, {
          isWithoutLogingView: true,
          isDisplayPrice: true,
          offer: _ctx._offer,
          "onUpdate:offer": _cache[3] || (_cache[3] = ($event: any) => ((_ctx._offer) = $event)),
          style: {"overflow-y":"hidden","overflow-x":"hidden"},
          "max-height": "59vh"
        }, null, 8, ["offer"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}